import {useEffect} from "react";

import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@components/ui/card";
import {useUser} from "@hooks/use-user";

export function AccountPage() {
    useEffect(() => {
        document.title = "Account - Pecunio Agents";
    }, []);

    const {user, loading} = useUser();

    if (loading) {
        return (
            <div className="flex items-center justify-center p-6">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    return (
        <div className="space-y-6 p-6">
            <div>
                <h1 className="text-3xl font-bold">Account</h1>
                <p className="text-muted-foreground">
                    Manage your account information and profile.
                </p>
            </div>

            <div className="grid gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle>Profile Information</CardTitle>
                        <CardDescription>
                            Your basic account information.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        {user ? (
                            <div className="space-y-2">
                                <div>
                                    <span className="font-medium">Email:</span> {user.email}
                                </div>
                                <div>
                                    <span className="font-medium">Name:</span> {user.firstName} {user.lastName}
                                </div>
                                {user.phone && (
                                    <div>
                                        <span className="font-medium">Phone:</span> {user.phone}
                                    </div>
                                )}
                                <div>
                                    <span
                                        className="font-medium">Email Verified:</span> {user.emailVerified ? 'Yes' : 'No'}
                                </div>
                                <div>
                                    <span
                                        className="font-medium">Account Type:</span> {user.isAdmin ? 'Admin' : user.isStaff ? 'Staff' : 'User'}
                                </div>
                            </div>
                        ) : (
                            <p className="text-muted-foreground">Unable to load user information.</p>
                        )}
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Account Settings</CardTitle>
                        <CardDescription>
                            Manage your account preferences and settings.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <p className="text-muted-foreground">
                            Account settings functionality coming soon...
                        </p>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Change Password</CardTitle>
                        <CardDescription>
                            Update your account password.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <p className="text-muted-foreground">
                            Password change functionality coming soon...
                        </p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}